module.exports = __webpack_public_path__ + "img/service3.edaa1b30.svg";